if (typeof window !== 'undefined') {
	import('@lottiefiles/dotlottie-react')
		.then((module) => {
			if (module.setWasmUrl) {
				module.setWasmUrl('/dotlottie-player.wasm');
			}
		})
		.catch(() => {
			console.error('❌ Failed to set DotLottie WASM URL');
		});
}

export {};
